import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import classNames from "classnames";

export default ({
  value,
  onChange,
  disabled = false,
  inputProps = false,
  formGroup = true,
  style,
  minDate = null,
  maxDate = null,
  inputClass = "form-control",
  placeHolder = "",
  startIcon,
  endIcon,
  startDate,
  endDate,
  preventOpenOnFocus = false,
  dateFormat,
  Rest,
}) => {
  return (
    <div
      className={classNames({
        formGroup: formGroup ? true : false,
        style: style ? true : false,
      })}
      style={style}
    >
      {startIcon && startIcon}
      <DatePicker
        preventOpenOnFocus={preventOpenOnFocus}
        disabled={disabled}
        focusSelectedMonth={true}
        showSecond={true}
        selected={value}
        className={inputClass}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        placeholderText={placeHolder}
        startDate={startDate}
        endDate={endDate}
        dateFormat={dateFormat}
        showWeekNumbers
        showDisabledMonthNavigation
        {...Rest}
      />
      {endIcon && endIcon}
      {inputProps.error && (
        <div className="errorMessage">{inputProps.error}</div>
      )}
    </div>
  );
};
// style={{ width: "100%" }}
